import { Box } from '@mui/material';
import classNames from 'classnames';
import React from 'react';

const SIZE_SMALL = 'small';
const SIZE_BIG = 'big';

const rootSx = (theme) => ({
  width: '24px',
  height: '24px',
  stroke: theme.tokens.marketplaceColor,
});

// Size lives in sx (px) because MUI's Box drops bare numeric width/height props as invalid CSS.
const smallSx = {
  width: '16px',
  height: '12px',
};

const IconCheckmark = ({ rootClassName = null, className = null, size = SIZE_BIG }) => {
  const sx = rootClassName ? undefined : rootSx;
  if (size === SIZE_SMALL) {
    const smallSize = rootClassName ? undefined : smallSx;
    return (
      <Box
        className={classNames(rootClassName, className)}
        component="svg"
        sx={smallSize}
        viewBox="0 0 16 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 2l-8 8-4-4"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.5"
        />
      </Box>
    );
  } else if (size === SIZE_BIG) {
    return (
      <Box
        className={classNames(rootClassName, className)}
        component="svg"
        strokeWidth="2"
        sx={sx}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22.6 1.2c-.4-.3-1-.2-1.3.2L7.8 19l-5.2-5c-.4-.4-1-.4-1.3 0-.4.3-.4.8 0 1l6 5.6.6.2s.2 0 .4-.4l14.3-18c.3-.5.2-1-.2-1" />
      </Box>
    );
  }
};

export default IconCheckmark;
